import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { GALLERY } from "@/data/gallery";
import { useGalleryStories, setStories } from "@/lib/galleryStories";

// Admin: write the story behind each gallery photo.
export default function AdminGalleryStories() {
  const { user } = useAuth();
  const live = useGalleryStories();
  const [draft, setDraft] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { setDraft({ ...live }); }, [live]);
  if (user && user.role !== "admin") return <div className="p-10">Admins only.</div>;
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/gallery/stories", { stories: draft }); setStories(Object.fromEntries(Object.entries(draft).filter(([, v]) => v.trim()))); toast.success("Stories saved: they're live in the gallery"); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
    finally { setBusy(false); }
  };
  const written = Object.values(draft).filter((v) => v?.trim()).length;
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="mx-auto max-w-4xl px-4 py-10">
        <Link to="/admin" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary" data-testid="stories-back"><ArrowLeft size={14} /> Admin</Link>
        <h1 className="mt-4 font-serif text-4xl">Gallery stories</h1>
        <p className="mt-2 text-sm text-muted-foreground">Write the story behind any photo. Photos with a story show "Tap to read story" in the gallery and on the weekly Featured Artist. Leave a box empty to show no story. {written} of {GALLERY.length} written.</p>
        <div className="sticky top-20 z-20 mt-4 rounded-2xl bg-background/90 py-2 backdrop-blur">
          <button onClick={save} disabled={busy} data-testid="stories-save" className="inline-flex items-center gap-1.5 rounded-full bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground disabled:opacity-50">{busy && <Loader2 size={14} className="animate-spin" />} Save stories</button>
        </div>
        <div className="mt-4 space-y-3">
          {GALLERY.map((g, i) => (
            <div key={g.src} className="flex gap-4 rounded-2xl border border-border bg-card p-3" data-testid={`story-row-${i}`}>
              <img src={g.src} alt={g.caption} className="h-24 w-20 shrink-0 rounded-xl object-cover" />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-bold uppercase tracking-wide">{g.name} {g.sub}</p>
                <textarea value={draft[g.src] || ""} onChange={(e) => setDraft({ ...draft, [g.src]: e.target.value })} maxLength={3000} rows={3}
                  placeholder="The story behind this photo…" data-testid={`story-input-${i}`}
                  className="mt-1.5 w-full rounded-lg border border-border bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none" />
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
